import { cn } from '~/shared/lib/cn'
import { Text } from '~/shared/ui'

export function Footer({ className }: { className?: string }) {
  return (
    <footer
      className={cn(
        'border-divider bg-surface-low sticky bottom-0 z-6 flex h-[44px] shrink-0 items-center justify-center border-t',
        className,
      )}
    >
      <Text
        className="text-text-secondary"
        appearance="BODY2"
      >
        Empowering Human Potential Through AI © 2025 Natera, Inc
      </Text>
    </footer>
  )
}
